import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged } from "rxjs";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { ScheduleDetails } from "src/app/common/interfaces/home/schedule-details.interface";
import { SidePanelDetails } from "src/app/common/interfaces/home/side-panel-details.interface";
import { LandingClientService } from "src/app/common/services/landing-page.client";
import { StorageService } from "src/app/common/services/storage.service";

@Injectable({
  providedIn: "root",
})
export class LandingPageService {
  private sidePanelData = new BehaviorSubject<SidePanelDetails>(null as any);
  private sidePanelVisible = new BehaviorSubject<boolean>(false);
  facilityId: string | null;
  scheduleDetails?: ScheduleDetails | null;
  hitCount = 0;
  sidePanelData$ = this.sidePanelData.asObservable();
  sidePanelVisible$ = this.sidePanelVisible.asObservable();

  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService
  ) {
    this.facilityId = this.storageService.getSelectedFacilityId();
  }

  async getScheduleAndBillingDetails() {
    this.storageService.isSelectedFacility.pipe(distinctUntilChanged()).subscribe((facilityId) => {
      this.facilityId = facilityId;
    });
    ++this.hitCount;
    if (this.hitCount < 2 && this.scheduleDetails) {
      return this.scheduleDetails;
    }
    if (this.facilityId === null) {
      return null as any;
    }
    const scheduleDetails = await firstValueFrom(
      this.landingClientService.getScheduleDetails(this.facilityId)
    );
    this.scheduleDetails = scheduleDetails;
    return scheduleDetails;
  }

  setSidePanelData(data: SidePanelDetails) {
    this.sidePanelData.next(data);
  }

  getIsToggleSidePanel(){
    return this.sidePanelVisible.value
  }

  toggleSidePanel(visible: boolean) {
    this.sidePanelVisible.next(visible);
  }
}
